import React from 'react'
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from 'configs/AppConfig'

export const commonRoutes = [
    {
        key: 'members.applicationForm.redirect',
        path: `${APP_PREFIX_PATH}/applicationForm/redirect/:id`,
        component: React.lazy(() => import('views/app-views/redirect/ApplicationFormCreateRedirect')),
    },
    {
        key: 'competition.redirect',
        path: `${APP_PREFIX_PATH}/competition/redirect/:accessCode`,
        component: React.lazy(() => import('views/app-views/redirect/JoinToCompetitionFormCreateRedirect')),
    },
    {
        key: 'competition.redirect.external',
        path: `${APP_PREFIX_PATH}/competition/external/redirect/:accessCode`,
        component: React.lazy(() => import('views/app-views/redirect/JoinToCompetitionExternalFormRedirect')),
    }
]

export const publicRoutes = [
    {
        key: 'login',
        path: `${AUTH_PREFIX_PATH}/login`,
        component: React.lazy(() => import('views/auth-views/authentication/login')),
    },
    {
        key: 'register',
        path: `${AUTH_PREFIX_PATH}/register`,
        component: React.lazy(() => import('views/auth-views/authentication/register')),
    },
    {
        key: 'forgot-password',
        path: `${AUTH_PREFIX_PATH}/forgot-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password')),
    },
    {
        key: 'reset-password',
        path: `${AUTH_PREFIX_PATH}/reset-password`,
        component: React.lazy(() => import('views/auth-views/authentication/forgot-password/reset-password.js')),
    },
    {
        key: 'members.applicationForm.public',
        path: `${AUTH_PREFIX_PATH}/applicationForm/public/:id`,
        component: React.lazy(() => import('views/auth-views/ApplicationFormCreatePublic')),
    },
]

export const protectedRoutes = [
    {
        key: 'admin.associationBankStatement.item',
        path: `${APP_PREFIX_PATH}/admin/associationBankStatementItem/item/index/:id/:serialNumber`,
        component: React.lazy(() => import('views/app-views/pages/admin/associationBankStatement/associationBankStatementItem/AssociationBankStatementItem.js')),
        requiredRole: 'ROLE_ADMIN',
    },
    {
        key: 'dashboard.default',
        path: `${APP_PREFIX_PATH}/dashboards/default`,
        component: React.lazy(() => import('views/app-views/pages/dashboards/default')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'document.index',
        path: `${APP_PREFIX_PATH}/documents/index`,
        component: React.lazy(() => import('views/app-views/pages/document/Index')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'template.index',
        path: `${APP_PREFIX_PATH}/template/index`,
        component: React.lazy(() => import('views/app-views/pages/document/template/Index')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'groups.index',
        path: `${APP_PREFIX_PATH}/groups/index`,
        component: React.lazy(() => import('views/app-views/pages/groups/Index')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'error.error-page-1',
        path: `${APP_PREFIX_PATH}/error/error`,
        component: React.lazy(() => import('views/auth-views/errors/error-page-1/index.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'groups.add',
        path: `${APP_PREFIX_PATH}/groups/add`,
        component: React.lazy(() => import('views/app-views/pages/groups/action/Add')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'groups.update',
        path: `${APP_PREFIX_PATH}/groups/update/:id`,
        component: React.lazy(() => import('views/app-views/pages/groups/action/Update')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'groups.view',
        path: `${APP_PREFIX_PATH}/groups/view/:id`,
        component: React.lazy(() => import('views/app-views/pages/groups/action/View')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'associationProfile.index',
        path: `${APP_PREFIX_PATH}/associationProfile/index`,
        component: React.lazy(() => import('views/app-views/pages/associationProfile/Index')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'members.index',
        path: `${APP_PREFIX_PATH}/members/index`,
        component: React.lazy(() => import('views/app-views/pages/members/Index')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'members.add',
        path: `${APP_PREFIX_PATH}/members/add`,
        component: React.lazy(() => import('views/app-views/pages/members/action/Add')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'members.applicationForm',
        path: `${APP_PREFIX_PATH}/members/applicationForm`,
        component: React.lazy(() => import('views/app-views/pages/members/applicationForm/ApplicationForm')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'members.update',
        path: `${APP_PREFIX_PATH}/members/update/:id`,
        component: React.lazy(() => import('views/app-views/pages/members/action/Update')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'members.view',
        path: `${APP_PREFIX_PATH}/members/view/:id`,
        component: React.lazy(() => import('views/app-views/pages/members/action/View')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'members.applicationForm.private',
        path: `${APP_PREFIX_PATH}/applicationForm/private/:id`,
        component: React.lazy(() => import('views/app-views/pages/members/applicationForm/ApplicationFormCreatePrivate')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'members.customProperties',
        path: `${APP_PREFIX_PATH}/customProperties`,
        component: React.lazy(() => import('views/app-views/pages/members/customProperties/Index')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'members.consentForm',
        path: `${APP_PREFIX_PATH}/consentForm/:id`,
        component: React.lazy(() => import('views/app-views/pages/members/applicationForm/consentForm/Index')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'admin.bamk',
        path: `${APP_PREFIX_PATH}/admin/bank`,
        component: React.lazy(() => import('views/app-views/pages/admin/bank/BankIndex')),
        requiredRole: 'PARTNER_ADMIN',
    },
    {
        key: 'admin.associationAccounts',
        path: `${APP_PREFIX_PATH}/admin/associationAccounts`,
        component: React.lazy(() => import('views/app-views/pages/admin/associationAccounts/Index')),
        requiredRole: 'PARTNER_ADMIN',
    },
    {
        key: 'admin.associationAccounts',
        path: `${APP_PREFIX_PATH}/admin/associationAccounts/:associationId`,
        component: React.lazy(() => import('views/app-views/pages/admin/associationAccounts/accounts/AssociationAccounts')),
        requiredRole: 'PARTNER_ADMIN',
    },
    {
        key: 'admin.legalEntity',
        path: `${APP_PREFIX_PATH}/admin/legalEntity`,
        component: React.lazy(() => import('views/app-views/pages/admin/legalEntity/LegalEntityIndex')),
        requiredRole: 'PARTNER_ADMIN',
    },
    {
        key: 'admin.coupons',
        path: `${APP_PREFIX_PATH}/admin/coupons`,
        component: React.lazy(() => import('views/app-views/pages/admin/package/coupon/CouponIndex')),
        requiredRole: 'PARTNER_ADMIN',
    },
    {
        key: 'admin.bankStatementLogics',
        path: `${APP_PREFIX_PATH}/admin/bankStatementsLogic`,
        component: React.lazy(() => import('views/app-views/pages/admin/logic/LogicIndex')),
        requiredRole: 'PARTNER_ADMIN',
    },
    {
        key: 'admin.packages',
        path: `${APP_PREFIX_PATH}/admin/packages`,
        component: React.lazy(() => import('views/app-views/pages/admin/package/PackageIndex')),
        requiredRole: 'PARTNER_ADMIN',
    },
    {
        key: 'admin.packages.programs',
        path: `${APP_PREFIX_PATH}/admin/packages/programs/:id`,
        component: React.lazy(() => import('views/app-views/pages/admin/package/programs/ProgramsOnPackage')),
        requiredRole: 'PARTNER_ADMIN',
    },
    {
        key: 'packages.index',
        path: `${APP_PREFIX_PATH}/packages/index`,
        component: React.lazy(() => import('views/app-views/pages/package/Index.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'admin.userRoles',
        path: `${APP_PREFIX_PATH}/admin/userRoles`,
        component: React.lazy(() => import('views/app-views/pages/admin/roles/userRoles')),
        requiredRole: 'PARTNER_ADMIN',
    },
    {
        key: 'admin.role.programs',
        path: `${APP_PREFIX_PATH}/admin/role/programs/:id`,
        component: React.lazy(() => import('views/app-views/pages/admin/roles/programs/ProgramsOnRole.js')),
        requiredRole: 'PARTNER_ADMIN',
    },
    {
        key: 'admin.sports',
        path: `${APP_PREFIX_PATH}/admin/sports`,
        component: React.lazy(() => import('views/app-views/pages/admin/sport/Sport.js')),
        requiredRole: 'ROLE_ADMIN',
    },
    {
        key: 'admin.title',
        path: `${APP_PREFIX_PATH}/admin/title`,
        component: React.lazy(() => import('views/app-views/pages/admin/title/Title.js')),
        requiredRole: 'ROLE_ADMIN',
    },
    {
        key: 'admin.levelOfFormalEducation',
        path: `${APP_PREFIX_PATH}/admin/levelOfFormalEducation`,
        component: React.lazy(() => import('views/app-views/pages/admin/levelOfFormalEducation/LevelOfFormalEducation.js')),
        requiredRole: 'ROLE_ADMIN',
    },
    {
        key: 'admin.levelOfNonFormalEducation',
        path: `${APP_PREFIX_PATH}/admin/levelOfNonFormalEducation`,
        component: React.lazy(() => import('views/app-views/pages/admin/levelOfNonFormalEducation/LevelOfNonFormalEducation.js')),
        requiredRole: 'ROLE_ADMIN',
    },
    {
        key: 'admin.professionalPersonRole',
        path: `${APP_PREFIX_PATH}/admin/professionalPersonRole`,
        component: React.lazy(() => import('views/app-views/pages/admin/professionalPersonRole/ProfessionalPersonRole.js')),
        requiredRole: 'ROLE_ADMIN',
    },
    {
        key: 'admin.professionalPersonUnderRole',
        path: `${APP_PREFIX_PATH}/admin/professionalPersonUnderRole/:id`,
        component: React.lazy(() => import('views/app-views/pages/admin/professionalPersonRole/ProfessionalPersonUnderRole.js')),
        requiredRole: 'ROLE_ADMIN',
    },
    {
        key: 'admin.areaOfEducation',
        path: `${APP_PREFIX_PATH}/admin/areaOfEducation`,
        component: React.lazy(() => import('views/app-views/pages/admin/areaOfEducation/AreaOfEducation')),
        requiredRole: 'ROLE_ADMIN',
    },
    {
        key: 'admin.employmentStatus',
        path: `${APP_PREFIX_PATH}/admin/employmentStatus`,
        component: React.lazy(() => import('views/app-views/pages/admin/employmentStatus/EmploymentStatus')),
        requiredRole: 'ROLE_ADMIN',
    },
    {
        key: 'admin.sports',
        path: `${APP_PREFIX_PATH}/admin/associationBankStatement`,
        component: React.lazy(() => import('views/app-views/pages/admin/associationBankStatement/Index.js')),
        requiredRole: 'ROLE_ADMIN',
    },
    {
        key: 'admin.partners',
        path: `${APP_PREFIX_PATH}/admin/partners`,
        component: React.lazy(() => import('views/app-views/pages/admin/partner/Partner.js')),
        requiredRole: 'ROLE_ADMIN',
    },
    {
        key: 'admin.changePackageAssociations',
        path: `${APP_PREFIX_PATH}/admin/changePackageAssociations`,
        component: React.lazy(() => import('views/app-views/pages/admin/changePackage/ChangePackageIndex.js')),
        requiredRole: 'ROLE_ADMIN',
    },
    {
        key: 'admin.partners.create',
        path: `${APP_PREFIX_PATH}/admin/partners/create`,
        component: React.lazy(() => import('views/app-views/pages/admin/partner/action/Create.js')),
        requiredRole: 'ROLE_ADMIN',
    },
    {
        key: 'admin.partners.update',
        path: `${APP_PREFIX_PATH}/admin/partners/update/:id`,
        component: React.lazy(() => import('views/app-views/pages/admin/partner/action/Update.js')),
        requiredRole: 'ROLE_ADMIN',
    },
    {
        key: 'sidenav.fixedAssets',
        path: `${APP_PREFIX_PATH}/fixedAssets/index`,
        component: React.lazy(() => import('views/app-views/pages/fixedAsset/Index.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'sidenav.blog',
        path: `${APP_PREFIX_PATH}/blog/index`,
        component: React.lazy(() => import('views/app-views/pages/blog/Index.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'blog.create',
        path: `${APP_PREFIX_PATH}/blog/create`,
        component: React.lazy(() => import('views/app-views/pages/blog/action/CreateBlog')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'blog.update',
        path: `${APP_PREFIX_PATH}/blog/update/:id`,
        component: React.lazy(() => import('views/app-views/pages/blog/action/UpdateBlog')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'blog.view',
        path: `${APP_PREFIX_PATH}/blog/view/:id`,
        component: React.lazy(() => import('views/app-views/pages/blog/action/ViewBlog')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'tag.index',
        path: `${APP_PREFIX_PATH}/blog/tags/index`,
        component: React.lazy(() => import('views/app-views/pages/blog/tag/Index')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'otherAttendances.index',
        path: `${APP_PREFIX_PATH}/otherAttendances/index`,
        component: React.lazy(() => import('views/app-views/pages/otherAttendances/Index')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'otherAttendances.update',
        path: `${APP_PREFIX_PATH}/otherAttendances/update/:id`,
        component: React.lazy(() => import('views/app-views/pages/otherAttendances/action/Update.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'otherAttendances.view',
        path: `${APP_PREFIX_PATH}/otherAttendances/view/:id`,
        component: React.lazy(() => import('views/app-views/pages/otherAttendances/view/View.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'otherAttendances.view',
        path: `${APP_PREFIX_PATH}/otherAttendances/view/:id`,
        component: React.lazy(() => import('views/app-views/pages/otherAttendances/view/View.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'trainingAttendances.view',
        path: `${APP_PREFIX_PATH}/trainingAttendance/index`,
        component: React.lazy(() => import('views/app-views/pages/trainingAttendances/Index.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'calendar.view',
        path: `${APP_PREFIX_PATH}/calendar/index`,
        component: React.lazy(() => import('views/app-views/pages/calendar/Index.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'codebook.view',
        path: `${APP_PREFIX_PATH}/codebook/index`,
        component: React.lazy(() => import('views/app-views/pages/codeBook/Index.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'users.view',
        path: `${APP_PREFIX_PATH}/users/index`,
        component: React.lazy(() => import('views/app-views/pages/users/Users.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'users.add',
        path: `${APP_PREFIX_PATH}/users/add`,
        component: React.lazy(() => import('views/app-views/pages/users/action/add.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'users.edit',
        path: `${APP_PREFIX_PATH}/users/edit/:id`,
        component: React.lazy(() => import('views/app-views/pages/users/action/edit.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'users.view',
        path: `${APP_PREFIX_PATH}/users/index`,
        component: React.lazy(() => import('views/app-views/pages/users/Users.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'bankStatement.view',
        path: `${APP_PREFIX_PATH}/bankStatements/index`,
        component: React.lazy(() => import('views/app-views/pages/bankStatements/Index.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'bankStatement.item.view',
        path: `${APP_PREFIX_PATH}/bankStatements/item/index/:id/:serialNumber`,
        component: React.lazy(() => import('views/app-views/pages/bankStatements/BankStatementItem/BankStatementItem.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'bankStatement.item.reposted',
        path: `${APP_PREFIX_PATH}/bankStatements/reposted`,
        component: React.lazy(() => import('views/app-views/pages/bankStatements/RepostedItems/RepostedItems')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'payments.view',
        path: `${APP_PREFIX_PATH}/payments/index`,
        component: React.lazy(() => import('views/app-views/pages/payments/Index.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'payments.view.unpaidPayments',
        path: `${APP_PREFIX_PATH}/payments-unpaid/index`,
        component: React.lazy(() => import('views/app-views/pages/payments/unpaidPayments/UnpaidPayments.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'payments.view.payment',
        path: `${APP_PREFIX_PATH}/payments/index/:id`,
        component: React.lazy(() => import('views/app-views/pages/payments/Payment.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'payments.view.report',
        path: `${APP_PREFIX_PATH}/payments/report`,
        component: React.lazy(() => import('views/app-views/pages/payments/report/Report.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'payments.view.hub3settings',
        path: `${APP_PREFIX_PATH}/payments/hub3Settings`,
        component: React.lazy(() => import('views/app-views/pages/payments/hub3Settings/Settings.js')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'dashboard.reportProblem',
        path: `${APP_PREFIX_PATH}/dashboards/reportProblem`,
        component: React.lazy(() => import('views/app-views/pages/dashboards/report-problem/Index')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'bankStatement.businessYear',
        path: `${APP_PREFIX_PATH}/dashboards/bankStatement/businessYear`,
        component: React.lazy(() => import('views/app-views/pages/bankStatements/BusinessYear/EditRow')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'sidenav.associationAccounts',
        path: `${APP_PREFIX_PATH}/associationAccounts/index`,
        component: React.lazy(() => import('views/app-views/pages/associationAccount/Index')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'sidenav.competitions',
        path: `${APP_PREFIX_PATH}/competitions/index`,
        component: React.lazy(() => import('views/app-views/pages/competitions/Index')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'sidenav.competitions.categories',
        path: `${APP_PREFIX_PATH}/competitions/categories`,
        component: React.lazy(() => import('views/app-views/pages/competitions/categories/Index')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'sidenav.competitions.privateJoin',
        path: `${APP_PREFIX_PATH}/competitions/join/:accessCode`,
        component: React.lazy(() => import('views/app-views/pages/competitions/CompetitionsJoinPrivate')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'sidenav.competitions.privateJoin.external',
        path: `${APP_PREFIX_PATH}/competitions/join/external/:accessCode`,
        component: React.lazy(() => import('views/app-views/pages/competitions/CompetitionsJoinExternalPrivate')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'sidenav.callsForApplication',
        path: `${APP_PREFIX_PATH}/callsForApplications/index`,
        component: React.lazy(() => import('views/app-views/pages/callsForApplication/Index')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'sidenav.callsForApplication.add',
        path: `${APP_PREFIX_PATH}/callsForApplications/add`,
        component: React.lazy(() => import('views/app-views/pages/callsForApplication/action/AddCallForApplication')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'sidenav.callsForApplication.update',
        path: `${APP_PREFIX_PATH}/callsForApplications/update/:id`,
        component: React.lazy(() => import('views/app-views/pages/callsForApplication/action/EditCallForApplication')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'sidenav.callsForApplication.view',
        path: `${APP_PREFIX_PATH}/callsForApplications/view/:id/:name`,
        component: React.lazy(() => import('views/app-views/pages/callsForApplication/ViewReports')),
        requiredRole: 'ROLE_USER',
    },
    {
        key: 'sidenav.typeOfExpense.view',
        path: `${APP_PREFIX_PATH}/callsForApplications/typeOfExpense/view`,
        component: React.lazy(() => import('views/app-views/pages/callsForApplication/typeOfExpense/Index')),
        requiredRole: 'ROLE_USER',
    }
]